import React, { useEffect, useState } from "react";
import Add from "../../../Assets/Icons/Add icon.svg";
import Odontogram from "./DentalForm";
import { set } from "lodash";

function SpecialityNotes({
  specialityForm,
  values,
  setValues,
  appointmentDetails,
}) {
  const [activeTab, setActiveTab] = useState("");
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const loggedUserObj = sessionStorage.getItem("login_result");
  const loggedUser = loggedUserObj ? JSON.parse(loggedUserObj) : null;

  useEffect(() => {
    if (specialityForm) {
      setActiveTab(specialityForm[0]?.templateName);
      setSelectedTemplate(specialityForm[0]);
    } else {
      if (loggedUser.user.userId === "DZU5051209") {
        setActiveTab("Odontogram");
      }
    }
  }, [specialityForm]);

  const handleSelectedTemplate = (tempObj, type) => {
    if (type === "auto") {
      setSelectedTemplate(tempObj);
      setActiveTab(tempObj.templateName);
    } else if (type === "manual") {
      setActiveTab(tempObj);
    }
  };

  return (
    <div className="">
      <div className="flex justify-between items-center mx-2 p-1">
        <div className="flex gap-5">
          <h3 className="text-sm font-sans font-semibold text-[#333333] mt-1">
            Specialty Notes
          </h3>
          <div className="flex bg-white rounded-full border">
            {specialityForm &&
              specialityForm?.map((tab, index) => (
                <button
                  key={index}
                  className={`px-6 py-1 text-lg font-semibold rounded-full transition-all 
              ${activeTab === tab.templateName
                      ? "bg-brand-primaryColor text-white shadow-md text-xs"
                      : "bg-white text-[#333333] hover:bg-gray-100 text-xs"
                    }`}
                  onClick={() => handleSelectedTemplate(tab, "auto")}
                >
                  {tab.templateName}
                </button>
              ))}
            {loggedUser.user.userId === "DZU5051209" && (
              <button
                className={`px-6 py-1 text-lg font-semibold rounded-full transition-all 
              ${activeTab === "Odontogram"
                    ? "bg-brand-primaryColor text-white shadow-md text-xs"
                    : "bg-white text-[#333333] hover:bg-gray-100 text-xs"
                  }`}
                onClick={() => handleSelectedTemplate("Odontogram", "manual")}
              >
                Odontogram
              </button>
            )}
          </div>
        </div>

        {/* <img src={Add} alt="" className="w-7 h-7 cursor-pointer" /> */}
      </div>
      <hr className="border mt-1" />
      <div className={`h-[270px] overflow-y-scroll `}>
        <div className="mt-4 w-full">
          <div className="border rounded-md">
            {specialityForm?.map((template, index) => (
              <div
                key={index}
                className={`p-3 bg-gray-50 text-sm text-gray-700 ${template?.templateId === selectedTemplate?.templateId &&
                    activeTab === selectedTemplate?.templateName
                    ? "block"
                    : "hidden"
                  }`}
              >
                <div
                  dangerouslySetInnerHTML={{
                    __html: template?.templateContent.replace(
                      /className=/g,
                      "class=",
                    ),
                  }}
                />
              </div>
            ))}
          </div>
          <div
            className={
              activeTab === "Odontogram" ? "block h-[300px]" : "hidden"
            }
          >
            <Odontogram values={values} setValues={setValues} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SpecialityNotes;
